import React from 'react';
import { Container, Row, Col, CardImg } from 'reactstrap';

const HowWeGetYouThere = (props) => {
  return (
    <div className="py-5 my-5">
      <Container>
        <Row className="justify-content-center pb-2">
          <Col sm={{ size: 11 }} md={{ size: 11 }} lg={{ size: 9 }}>
            <div className='position-relative'>
              <h1 className="fc-line text-center mt-5 mb-5 pb-2">
                How We Get You There
            </h1>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 4}} className='py-5'>
            <Row className="justify-content-center">
              <Col xs={{ size: 5 }} className="icon-container d-flex justify-content-center justify-content-lg-end">
                <CardImg
                  className="ca-icons"
                  top
                  width="100%"
                  src="img/cyber-online-portal-icon-v2.png"
                  alt="Card image cap"
                />
              </Col>
              <Col xs={{ size: 7 }}>
                <h3 className="left-align">
                  {" "}
                  Online Portal
              </h3>
                <p className="left-align ">
                  Access your team progress daily
              </p>
              </Col>
            </Row>
          </Col>

          <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 4}} className='py-5'>
            <Row className="justify-content-center">
              <Col xs={{ size: 5 }} className="icon-container d-flex justify-content-center justify-content-lg-end">
                <CardImg
                  className="ca-icons"
                  top
                  width="100%"
                  src="img/cyber-certifications-icon-v2.png"
                  alt="Card image cap"
                />
              </Col>
              <Col xs={{ size: 7 }}>
                <h3 className="left-align">
                  {" "}
                  Certifications
              </h3>
                <p className="left-align ">
                  Providing credible training for the team
              </p>
              </Col>
            </Row>
          </Col>

          <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 4}} className='py-5'>
            <Row className="justify-content-center">
              <Col xs={{ size: 5 }} className=' d-flex justify-content-center justify-content-lg-end'>
                <CardImg
                  className="ca-icons"
                  top
                  width="100%"
                  src="img/cyber-assessments-icon-v2.png"
                  alt="Card image cap"
                />
              </Col>
              <Col xs={{ size: 7 }}>
                <h3 className="left-align">
                  {" "}
                  Assessments
              </h3>
                <p className="left-align ">
                  Ensuring your team gets what is needed
              </p>
              </Col>
            </Row>
          </Col>
          <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 4}} className='py-5'>
            <Row className="justify-content-center">
              <Col xs={{ size: 5 }} className="icon-container d-flex justify-content-center justify-content-lg-end">
                <CardImg
                  className="ca-icons"
                  top
                  width="100%"
                  src="img/cyber-hands-on-icon-v2.png"
                  alt="Card image cap"
                />
              </Col>
              <Col xs={{ size: 7 }}>
                <h3 className="left-align">
                  {" "}
                  Hands-On
              </h3>
                <p className="left-align ">
                  Apply knowledge in real ways
              </p>
              </Col>
            </Row>
          </Col>
          <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 4}} className='py-5'>
            <Row className="justify-content-center">
              <Col xs={{ size: 5 }} className="icon-container d-flex justify-content-center justify-content-lg-end">
                <CardImg
                  className="ca-icons"
                  top
                  width="100%"
                  src="img/cyber-group-labs-icon-v2.png"
                  alt="Card image cap"
                />
              </Col>
              <Col xs={{ size: 7 }}>
                <h3 className="left-align">
                  {" "}
                  Group Labs
              </h3>
                <p className="left-align ">
                  Creating a team approach for success
              </p>
              </Col>
            </Row>
          </Col>
          <Col xs={{size: 12}} sm={{ size: 6}} lg={{size: 4}} className='py-5'>
            <Row className="justify-content-center">
              <Col xs={{ size: 5 }} className="icon-container d-flex justify-content-center justify-content-lg-end">
                <CardImg
                  className="ca-icons"
                  top
                  width="100%"
                  src="img/cyber-confidence-icon-v2.png"
                  alt="Card image cap"
                />
              </Col>
              <Col xs={{ size: 7 }}>
                <h3 className="left-align">
                  {" "}
                  Confidence
              </h3>
                <p className="left-align ">
                  Step out knowing your team is equipped
              </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default HowWeGetYouThere;
